/** Re-export SoT — frontend/src/shared/localizedText.js */
module.exports = require('../shared/localizedText');
